export function formatCurrency(value: number, decimal: number = 0, hideTag: boolean = false) {
  const formatter = new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: decimal,
  })

  // hilangkan rp?
  if (hideTag) return formatter.format(value).replace(/^Rp\s?/, '')
  return formatter.format(value)
}
